
import Notification from '../notification/index.vue';

export default {
  name: 'rzNotificationCenter',
  components: {
    Notification,
  },
  data() {
    return {
      notifications: [],
    };
  },
  mounted() {
    this.$bus.$on('add-notification', (data) => {
      this.addNotification(data);
    });
    this.$bus.$on('add-removable-notification', (data) => {
      this.addRemovableNotification(data);
    });
  },
  methods: {
    rendered(el, index) {
      setTimeout(() => {
        this.notifications[index].initial = false;
      }, 500);
    },
    addNotification({text, theme = 'info'}) {
      this.notifications.push({
        theme,
        text,
        hide: false,
        initial: true,
      });

      return this.notifications.length - 1;
    },
    addRemovableNotification({theme, text, seconds}) {
      const index = this.addNotification({theme, text});

      setTimeout(() => {
        this.removeNotification(index);
      }, seconds * 1000);
    },
    removeNotification(index) {
      this.notifications[index].hide = true;

      setTimeout(() => {
        this.notifications.splice(index, 1);
      }, 500);
    },
    clear() {
      this.notifications.length = 0;
    }
  },
};
